/**
 * Dữ liệu mẫu của màn Tóm tắt văn bản (module `van-ban`, ADR-0084) cho `?mock=` và chạy `pnpm dev`
 * không có backend. Không quyết màu ở đây (CLAUDE.md): bảng tông ở `modules/xu-ly-van-ban/constants.ts`.
 */
import type { ChiTietTomTat } from '../modules/xu-ly-van-ban/types-tom-tat';

const GOC_1 = `Căn cứ Kế hoạch chuyển đổi số năm 2026 của Ủy ban nhân dân tỉnh, Sở Thông tin và Truyền thông đề nghị các sở, ban, ngành rà soát hiện trạng hạ tầng công nghệ thông tin, cơ sở dữ liệu chuyên ngành và mức độ cung cấp dịch vụ công trực tuyến.

Kết quả rà soát gửi về Sở trước ngày 30/11/2026 để tổng hợp, báo cáo Ủy ban nhân dân tỉnh. Đơn vị nào chậm trễ chịu trách nhiệm trước Chủ tịch Ủy ban nhân dân tỉnh.`;

const TOM_1 = `## Nội dung chính
- Các sở, ban, ngành **rà soát hạ tầng CNTT**, cơ sở dữ liệu và dịch vụ công trực tuyến.
- Gửi kết quả về Sở Thông tin và Truyền thông **trước 30/11/2026**.

Đơn vị chậm trễ chịu trách nhiệm trước Chủ tịch UBND tỉnh.`;

const GOC_2 = `Báo cáo kết quả thực hiện nhiệm vụ quý III năm 2026 của Văn phòng. Trong quý, Văn phòng đã tham mưu ban hành 45 văn bản, tổ chức 12 cuộc họp giao ban, hoàn thành 96% nhiệm vụ được giao đúng hạn.`;

const GOC_3 = `Thông báo lịch nghỉ Tết Nguyên đán năm 2027 đối với cán bộ, công chức, viên chức và người lao động.`;

export const MOCK_TOM_TAT: ChiTietTomTat[] = [
  {
    id: '6f1c2a10-0000-4000-8000-000000000001',
    document_name: 'Công văn về việc rà soát hạ tầng chuyển đổi số',
    document_type: 'Công văn',
    status: 'COMPLETED',
    source: null,
    external_doc_id: null,
    original_char_count: GOC_1.length,
    summary_char_count: TOM_1.length,
    reduction_ratio: 58.4,
    creator_name: 'Nguyễn Văn An',
    user_id: null,
    llm_model: 'gemini-3-flash-preview',
    created_at: '2026-10-20T02:10:00Z',
    updated_at: '2026-10-20T02:11:00Z',
    original_content: GOC_1,
    summary_content: TOM_1,
    original_filename: 'cong-van-ra-soat.pdf',
    token_usage: { prompt_tokens: 812, completion_tokens: 140, total_tokens: 952 },
    error_message: null,
  },
  {
    id: '6f1c2a10-0000-4000-8000-000000000002',
    document_name: 'Báo cáo kết quả thực hiện nhiệm vụ quý III',
    document_type: 'Báo cáo',
    status: 'PENDING',
    source: 'QLVB',
    external_doc_id: 'QLVB-2026-1182',
    original_char_count: GOC_2.length,
    summary_char_count: null,
    reduction_ratio: null,
    creator_name: null,
    user_id: null,
    llm_model: null,
    created_at: '2026-10-21T08:30:00Z',
    updated_at: '2026-10-21T08:30:00Z',
    original_content: GOC_2,
    summary_content: null,
    original_filename: 'bao-cao-quy-3.docx',
    token_usage: null,
    error_message: null,
  },
  {
    id: '6f1c2a10-0000-4000-8000-000000000003',
    document_name: 'Thông báo lịch nghỉ Tết Nguyên đán 2027',
    document_type: 'Thông báo',
    status: 'FAILED',
    source: null,
    external_doc_id: null,
    original_char_count: GOC_3.length,
    summary_char_count: null,
    reduction_ratio: null,
    creator_name: 'Trần Thị Bình',
    user_id: null,
    llm_model: null,
    created_at: '2026-10-22T01:00:00Z',
    updated_at: '2026-10-22T01:01:00Z',
    original_content: GOC_3,
    summary_content: null,
    original_filename: null,
    token_usage: null,
    error_message: 'Dịch vụ AI trả lỗi HTTP 500, vui lòng thử lại sau.',
  },
];

export const MOCK_CAU_TOM_TAT = {
  khongThay: 'Văn bản không tồn tại',
  daGuiYeuCau: 'Đã gửi yêu cầu tóm tắt AI, vui lòng chờ kết quả',
  tomTatGia: '## Nội dung chính\n- Bản tóm tắt minh hoạ do AI tạo ở bản dữ liệu mẫu.',
  daPhanCong: (n: number) => `AI đã tạo ${n} nhiệm vụ từ bản tóm tắt, giao cho các phòng ban, cá nhân phù hợp.`,
  chuaTomTat: 'Văn bản chưa có bản tóm tắt. Vui lòng tóm tắt trước khi phân công.',
  soanGia: '<p>Nội dung văn bản minh hoạ do AI soạn ở bản dữ liệu mẫu.</p>',
  hoTenGia: 'Nguyễn Văn An',
  tenMauGia: 'Văn bản',
};
